<script lang="ts">
    import { TestStatus, Todo } from "../../../shared/wspayload";
    import { currentTest, messageInfo } from "../store";
    import Animate from "../components/Animate.svelte";
    import Icon from "../components/Icon.svelte";
    import Submit from "../components/Submit.svelte";

    let test: Todo;
    currentTest.subscribe((value) => (test = value));
    if (test?.status == TestStatus.success) messageInfo.clear();
</script>

<main>
    <div class="text">
        {#if test?.status == TestStatus.success}
            <Animate color="green" backColor="lightgreen">
                <Icon icon="emoji-smile" />
                Merci !
            </Animate>
        {:else}
            <Animate color="red" backColor="crimson">
                <Icon icon="emoji-angry" />
                Echec à l'étape : <br />
                {test?.guidelines || "Connexion impossible"}
            </Animate>
        {/if}
    </div>

    <Submit icon="arrow-repeat">Recommencer</Submit>
</main>

<style>
    main {
        text-align: center;
    }

    .text {
        padding: 150px 0px;
    }
</style>
